import { Loading } from 'components/Icons'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { axiosInstance as api } from 'services/api'
import { format } from 'date-fns'
import UserStore from 'services/userLocalStorage'
import './styles.sass'

function MyAssessmentsPortal() {
  const { t } = useTranslation()
  const { auth } = useSelector((store) => store)
  const [loading, setLoading] = useState(false)
  const [, setMessage] = useState({})
  const [forms, setForms] = useState([])
  const portalId = window.endPoints.api.portalID

  let token = auth.signinToken == null ? UserStore.getToken() : auth.signinToken

  const getForms = useCallback(async () => {
    setLoading(true)
    setMessage({})
    const requestOptions = {
      method: 'GET',
      url: `/selfservice/forms/my_assessments/${portalId}`,
      headers: { Authorization: `Bearer ${token}` },
      data: { formType: 'PORTAL', limit: 1000 },
    }
    try {
      const { data } = await api(requestOptions)
      const forms = data.map((form) => ({
        ...form,
        createdAt: form?.createdAt ? format(new Date(form?.createdAt), "dd/MM/yyyy HH:mm:ss") : null,
        lastSendDate: form?.lastSendDate ? format(new Date(form?.lastSendDate), "dd/MM/yyyy HH:mm:ss") : null,
      }));
      setForms(forms)
    } catch (error) {
      console.error({ error })
      setMessage({ type: 'error', message: t('genericError') })
    } finally {
      setLoading(false)
    }
  }, [portalId, t, token])

  useEffect(() => {
    getForms()
  }, [getForms])

  return (
    <section>
      <header className='pvt-content-header custom'>
        <h1
          style={{
            margin: '0 0 5px',
            fontSize: '24px',
            fontWeight: 'bold',
            color: 'var(--txt-surface)',
          }}
        >
          {t('label.self.service.my.assessments.label')}
        </h1>
        <p className='pvt-content-desc custom'>{t('label.self.service.my.assessments.description')}</p>
      </header>
      <div className='pvt-card pvt-card-100'>
        {loading ? (
          <Loading />
        ) : (
          <div className='dsar-form'>
            {forms.length > 0 ? (
              <div className='table-responsive'>
                <table
                  className='table table-striped table-hover col-sm-11'
                  style={{ marginLeft: '20px', marginTop: '10px', width: '100%' }}
                >
                  <thead>
                    <tr>
                      <th>{t('assessment.form.table.title')}</th>
                      <th>{t('dm.default.creationDate')}</th>
                      <th>{t('dm.default.lastSendDate')}</th>
                      <th>{t('yourRequests.table.status')}</th>
                      {forms.find(response => response.calculatedScore !== null) && <th>{t('assessment.score')}</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {forms.map((response) => (
                      <tr key={response.id}>
                        <td>{response.formName}</td>
                        <td>{response.createdAt}</td>
                        <td>{response.lastSendDate}</td>
                        <td>{t(`dataMapping.dm-form.status.${response.sendRespondentStatus}`)}</td>
                        <td>{response.calculatedScore !== null && response.calculatedScore}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className='pvt-content-desc custom'>{t('assessment.form.assessment.respondent.not.found')}</p>
            )}
          </div>
        )}
      </div>
    </section>
  )
}

export default MyAssessmentsPortal
